import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const FallingStarShape = ({
  width = 36,
  height = 36,
  fillColor = '#FFFFFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M20.7 7.96011C19.5422 5.00864 18.9632 3.53289 17.7523 3.35097C16.5417 3.16906 15.501 4.40142 13.4195 6.86616L12.881 7.50381C12.2895 8.20421 11.9938 8.55442 11.5917 8.75439C11.1895 8.95436 10.7267 8.98144 9.80068 9.03562L8.95768 9.08496C5.69951 9.27566 4.07035 9.37101 3.50502 10.4362C2.93968 11.5014 3.81252 12.8309 5.55818 15.4901L6.00985 16.178C6.50585 16.9337 6.75385 17.3115 6.82085 17.7429C6.88785 18.1742 6.76635 18.6104 6.52301 19.4825L6.30168 20.2767C5.44585 23.346 5.01785 24.8807 5.87918 25.7209C6.74052 26.5612 8.32068 26.1505 11.481 25.3292L12.2987 25.1167C13.1967 24.8834 13.6458 24.7667 14.0893 24.8332C14.5328 24.8999 14.9207 25.1424 15.6962 25.6272L16.4024 26.0687C19.1317 27.7749 20.4964 28.628 21.594 28.0822C22.6917 27.5362 22.7955 25.9529 23.003 22.7862L23.0567 21.9669C23.1157 21.067 23.1452 20.617 23.3523 20.2269C23.5594 19.8367 23.9206 19.5504 24.6432 18.9779L25.301 18.4565C27.8437 16.4418 29.115 15.4344 28.9321 14.2568C28.7492 13.0792 27.2331 12.5112 24.201 11.3754L23.4166 11.0815C22.555 10.7587 22.1242 10.5974 21.8087 10.2896C21.4932 9.98176 21.3285 9.56241 20.9995 8.72369L20.7 7.96011Z"
      fill="white"
      fillOpacity="0.15"
    />
    <path
      d="M31.15 15.9879C35.2118 19.8688 37.875 26.343 36.1146 36.667C34.5433 32.3276 30.2379 28.7345 25.1464 26.588C25.324 25.6001 25.4029 24.394 25.486 23.1221L25.5509 22.1303C25.5661 21.8995 25.5776 21.7245 25.5899 21.5738C25.595 21.5113 25.5998 21.459 25.6043 21.4148C25.643 21.3816 25.6902 21.3421 25.7481 21.2948C25.8688 21.1961 26.0104 21.0838 26.1954 20.9371L26.9874 20.3096C28.1426 19.3946 29.2186 18.5423 29.9585 17.7563C30.3803 17.3083 30.8521 16.7173 31.15 15.9879Z"
      fill="white"
      fillOpacity="0.1"
    />
    <path
      d="M22.7556 25.7051C22.7641 25.6428 22.7725 25.5791 22.7806 25.5143L22.6871 25.6833C22.71 25.6906 22.7328 25.6978 22.7556 25.7051Z"
      fill="white"
      fillOpacity="0.2"
    />
  </svg>
);

export default FallingStarShape;
